import { ILayoutStore } from "../models/LayoutStore";
import { useLayoutStore } from "../useLayoutStore";

export const useSelectIsSidebarOpen = (): ILayoutStore["isSidebarOpen"] => {
  const { isSidebarOpen } = useLayoutStore() as ILayoutStore;

  return isSidebarOpen;
};
